import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {get as _get, isNil as _isNil} from 'lodash';

import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {PRODUCT_LCPP} from '@constants/variables';
import ClipLifetimeDescription from '@modules/client/utils/ClipLifeTimeDescription';

import ClientProductForm from './ClientProductForm';
import {deleteSuccessCallback, setClientProductsEntity} from '../utils/clientProducts';

class ClientProductLcppForm extends ClientProductForm {
    componentDidMount() {
        super.componentDidMount();

        const entityName = 'client',
            params = {
                clientData: this.props.clientData,
                entityName,
                setEntity: this.props.Entity.setEntity,
            };

        this.setCreateSuccessCallback((response) => {
            this.props.Entity.setEntity({
                name: entityName,
                data: {...this.props.clientData,
                    clientProducts: this.props.clientData.clientProducts.concat(
                        response.data.createClientProductLcpp.client_product
                    ),
                },
            });

            this.props.history.push(getLink('clients.products.lcpp.editGeoRestrictions', {
                id: this.props.match.params.id,
            }));
        });

        this.setUpdateSuccessCallback((response) => {
            const clientProductLcppIndex = this.props.clientData.clientProducts.findIndex(clientProduct =>
                    PRODUCT_LCPP === convertToInt(clientProduct.product.id)
                ),
                clientProducts = {};

            clientProducts[clientProductLcppIndex] = {
                ...response.data.updateClientProductLcpp.client_product,
            };
            params.clientProducts = clientProducts;

            setClientProductsEntity(params);
        });

        this.setDeleteSuccessCallback(() => {
            params.formParamsId = this.props.formParams.id;
            params.historyPush = this.props.history.push;

            deleteSuccessCallback(params);
        });
    }

    componentDidUpdate(prevProps) {
        const {
            formParams,
            GraphQLEntityData,
            GraphQLOptionsData,
        } = this.props;

        const isAddForm = _get(formParams, 'isAddForm');
        const clientProductsLcpp = _get(GraphQLEntityData, 'clientProductsLcpp', []);
        const entityLoading = _get(GraphQLEntityData, 'loading', false);
        const optionsProduct = _get(GraphQLOptionsData, 'product');
        const optionsLoading = _get(GraphQLOptionsData, 'loading', false);
        let augmentedPrevProps = prevProps;

        if (!optionsLoading && !entityLoading && !this.state.dataReceived) {
            if (!isAddForm && 0 < clientProductsLcpp.length) {
                augmentedPrevProps = { ...prevProps, clientProduct: clientProductsLcpp[0].client_product };
                this.setField('id', {defaultValue: convertToInt(clientProductsLcpp[0].id)});
            }

            this.handleInitialSlaFieldVisibility(isAddForm, clientProductsLcpp, optionsProduct);
            this.setClipLifetimeFieldDescription(optionsProduct);
            super.componentDidUpdate(augmentedPrevProps);
        }
    }

    prepareDataForSubmit(data) {
        data = {...data, product: PRODUCT_LCPP};

        const dataToSubmit = super.prepareDataForSubmit(data);

        return {...dataToSubmit,
            clip_lifetime: data.clip_lifetime ? convertToInt(data.clip_lifetime) : null,
            notification_api_url: data.notification_api_url || null,
            api_key: data.api_key || null,
        };
    }

    setClipLifetimeFieldDescription(optionsProduct) {
        if (!_isNil(optionsProduct.clip_lifetime)) {
            this.setField('clip_lifetime', {
                props: {
                    description: <ClipLifetimeDescription clipLifetime={optionsProduct.clip_lifetime} />,
                },
            });
        }
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity']),
    mapStateToProps = (state) => ({clientData: state.app.entities.client || null});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientProductLcppForm));
